import { KitchenMaterial, SURROUND_TEXTURE_DIMENSION } from '@rta/rta-blueprint-library';

import { DesignerOptions } from '@r-core';

type CreateCornerSymbolProps = {
	material: KitchenMaterial | null;
	options: DesignerOptions;
};

export const CreateCornerPattern = (props: CreateCornerSymbolProps): React.ReactElement => {
	const { material, options } = props;

	if (material === null) return <></>;

	// texture
	// const materialAsset = textureMap[kitchen.material.surround] ?? textureMap.unknown;
	const materialAsset = material.surround;
	const materialScaleWidth = SURROUND_TEXTURE_DIMENSION * materialAsset.cornerScale;
	const materialScaleHeight = SURROUND_TEXTURE_DIMENSION * materialAsset.cornerScale;

	// console.log('CreateCountertopSymbol', { countertopWidth, countertopThickness});

	return (
		<defs>
			<pattern id="corner-texture" x="0" y="0" height={materialScaleHeight} width={materialScaleWidth} patternUnits="userSpaceOnUse">
				<image href={`${options.assetsBaseUrl}/textures/${materialAsset.cornerTexture}${options.assetsSasToken}`} x="0" y="0" width={materialScaleWidth} height={materialScaleHeight} />
			</pattern>
		</defs>
	);
};
